(function () {
  const cfg = window.ARCUBE_CONFIG || {};
  const API = cfg.apiBase || '';

  // Map Arcube category → { variantId, handle (Shopify product URL slug) }
  const PRODUCT_MAP = {
    FAST_TRACK:    { variantId: '57507048063324', handle: 'fast-track-barcelona-el-prat' },
    LOUNGE_ACCESS: { variantId: '57507044491612', handle: 'aspire-lounge-londres-heathrow-t5' },
    // Add more as products are created in Shopify:
    // BAGGAGE_PROTECTION: { variantId: 'VARIANT_ID', handle: 'product-handle' },
    // CARBON_OFFSET:      { variantId: 'VARIANT_ID', handle: 'product-handle' },
    // ESIM:               { variantId: 'VARIANT_ID', handle: 'product-handle' },
    // AIRPORT_TRANSFER:   { variantId: 'VARIANT_ID', handle: 'product-handle' },
    // CAR_RENTAL:         { variantId: 'VARIANT_ID', handle: 'product-handle' },
  };

  let state = { pnr: '', passengers: [], selected: {}, recommendations: [] };

  const $ = id => document.getElementById(id);

  function showStep(name) {
    document.querySelectorAll('.arcube-step').forEach(el => el.classList.remove('arcube-step--active'));
    $(`arcube-step-${name}`).classList.add('arcube-step--active');
  }

  function buildPassengers(adults, children, infants) {
    const pax = [];
    for (let i = 0; i < adults; i++) pax.push({ id: `ADT${i + 1}`, type: 'ADT' });
    for (let i = 0; i < children; i++) pax.push({ id: `CHD${i + 1}`, type: 'CHD' });
    for (let i = 0; i < infants; i++) pax.push({ id: `INF${i + 1}`, type: 'INF' });
    return pax;
  }

  function flattenResult(result) {
    if (!result || typeof result !== 'object') return [];
    return Object.values(result).flat().filter(Boolean);
  }

  const CATEGORIES = {
    CARBON_OFFSET:      { label: 'Compensación CO₂',    icon: '🌿', cls: 'cat-carbon' },
    BAGGAGE_PROTECTION: { label: 'Protección equipaje',  icon: '🧳', cls: 'cat-baggage' },
    LOUNGE_ACCESS:      { label: 'Acceso sala VIP',      icon: '🛋', cls: 'cat-lounge' },
    ESIM:               { label: 'eSIM',                 icon: '📱', cls: 'cat-esim' },
    ESIMS:              { label: 'eSIM',                 icon: '📱', cls: 'cat-esim' },
    TRAVEL_INSURANCE:   { label: 'Seguro de viaje',      icon: '🛡', cls: 'cat-travel' },
    SEAT_UPGRADE:       { label: 'Mejora de asiento',    icon: '💺', cls: 'cat-seat' },
    FAST_TRACK:         { label: 'Fast Track',           icon: '⚡', cls: 'cat-seat' },
    AIRPORT_TRANSFER:   { label: 'Traslado aeropuerto',  icon: '🚗', cls: 'cat-default' },
    CAR_RENTAL:         { label: 'Alquiler de coche',    icon: '🚙', cls: 'cat-default' },
  };

  function getCat(cat) {
    return CATEGORIES[cat] || { label: cat, icon: '✈', cls: 'cat-default' };
  }

  function formatPrice(price, currency) {
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency || 'USD' }).format(price);
  }

  function getItemId(item) {
    return item.ancillary_id || item.id || item.ancillaryId;
  }

  function renderGrid(recommendations) {
    const grid = $('arcube-grid');
    const empty = $('arcube-empty');

    if (!recommendations || recommendations.length === 0) {
      grid.innerHTML = '';
      empty.style.display = 'block';
      return;
    }
    empty.style.display = 'none';

    grid.innerHTML = recommendations.map(item => {
      const id = getItemId(item);
      const price = item.price || item.minimum_price || 0;
      const currency = item.currency || 'USD';
      const cat = getCat(item.category);

      const subProducts = (item.metadata && item.metadata.products ? item.metadata.products : []).filter(p => p && (p.product_name || p.name));
      const subHtml = subProducts.length > 1
        ? `<ul class="arcube-details">${subProducts.map(p =>
            `<li><span>${p.product_name || p.name}</span><strong>${formatPrice(p.price || price, currency)}</strong></li>`
          ).join('')}</ul>`
        : '';

      const imgHtml = item.image
        ? `<img class="arcube-product-img" src="${item.image}" alt="${item.name}" loading="lazy" />`
        : `<div class="arcube-product-img-placeholder">${cat.icon}</div>`;

      const shopifyProduct = PRODUCT_MAP[item.category];
      const productUrl = shopifyProduct ? `/products/${shopifyProduct.handle}` : null;

      return `
        <div class="arcube-card arcube-card--product${productUrl ? ' arcube-card--linked' : ''}" data-id="${id}" ${productUrl ? `data-url="${productUrl}"` : ''}>
          ${imgHtml}
          <div class="arcube-product-info">
            <span class="arcube-category-tag ${cat.cls}">${cat.icon} ${cat.label}</span>
            <h3>${item.name || 'Servicio adicional'}</h3>
            <p class="arcube-product-desc">${item.description || ''}</p>
            ${subHtml}
            <div class="arcube-product-footer">
              <div>
                ${subProducts.length > 1 ? `<span class="arcube-price-from">desde</span>` : ''}
                <span class="arcube-price">${formatPrice(price, currency)}</span>
              </div>
              <div class="arcube-card-actions">
                ${productUrl ? `<a href="${productUrl}" class="arcube-btn arcube-btn--ghost arcube-btn--info" target="_blank">Ver más</a>` : ''}
                ${shopifyProduct ? `<button class="arcube-btn arcube-btn--select" data-id="${id}">Seleccionar</button>` : `<span class="arcube-badge-unavailable">Próximamente</span>`}
              </div>
            </div>
          </div>
        </div>
      `;
    }).join('');

    grid.querySelectorAll('.arcube-btn--select').forEach(btn => {
      btn.addEventListener('click', () => toggleSelect(btn.dataset.id, recommendations));
    });
  }

  function toggleSelect(id, recommendations) {
    const item = recommendations.find(r => getItemId(r) === id);
    if (!item) return;

    if (state.selected[id]) {
      delete state.selected[id];
    } else {
      state.selected[id] = item;
    }

    const card = document.querySelector(`.arcube-card--product[data-id="${id}"]`);
    const btn = document.querySelector(`.arcube-btn--select[data-id="${id}"]`);
    if (card) card.classList.toggle('is-selected', !!state.selected[id]);
    if (btn) {
      btn.textContent = state.selected[id] ? '✓ Seleccionado' : 'Seleccionar';
      btn.classList.toggle('arcube-btn--selected', !!state.selected[id]);
    }

    updateCartBar();
  }

  function updateCartBar() {
    const items = Object.values(state.selected);
    const bar = $('arcube-cart-bar');
    if (items.length === 0) { bar.style.display = 'none'; return; }

    const total = items.reduce((sum, i) => sum + (i.price || i.minimum_price || 0), 0);
    const currency = items[0]?.currency || 'USD';
    $('arcube-cart-count').textContent = `${items.length} servicio${items.length > 1 ? 's' : ''} seleccionado${items.length > 1 ? 's' : ''}`;
    $('arcube-cart-total').textContent = formatPrice(total, currency);
    bar.style.display = 'flex';
  }

  async function addToCart() {
    const items = Object.values(state.selected);
    if (!items.length) return;

    const btn = $('arcube-checkout-btn');
    btn.textContent = 'Añadiendo...';
    btn.disabled = true;

    try {
      // Build cart items — each ancillary as its own Shopify line item
      const cartItems = items.map(item => {
        const shopifyProduct = PRODUCT_MAP[item.category];
        const variantId = shopifyProduct && shopifyProduct.variantId;
        if (!variantId) return null;
        return {
          id: variantId,
          quantity: 1,
          properties: {
            PNR: state.pnr,
            Servicio: item.name || item.description || '',
            _precio_arcube: `${item.price || item.minimum_price || 0} ${item.currency || 'USD'}`,
            _arcube_id: item.ancillary_id || item.id || '',
            _arcube_category: item.category || '',
            _arcube_data: JSON.stringify({
              id: item.ancillary_id || item.id || '',
              ancillaryId: item.ancillary_id || item.id || '',
              vendor: item.vendor || item.category || '',
              price: item.price || item.minimum_price || 0,
              currency: item.currency || 'USD',
              quantity: 1,
              description: item.name || item.description || '',
              vendorReferenceId: item.vendorReferenceId || item.vendor_reference_id || '',
              serviceDetails: item.serviceDetails || item.service_details || {},
              metadata: item.metadata || {},
            }),
          },
        };
      }).filter(Boolean);

      const unmapped = items.filter(i => !PRODUCT_MAP[i.category]);
      if (unmapped.length && cartItems.length === 0) {
        alert(`No hay producto de Shopify configurado para: ${unmapped.map(i => i.category).join(', ')}`);
        btn.textContent = 'Añadir al carrito →';
        btn.disabled = false;
        return;
      }

      if (cartItems.length === 0) {
        btn.textContent = 'Añadir al carrito →';
        btn.disabled = false;
        return;
      }

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cartItems }),
      });

      window.location.href = '/cart';
    } catch (err) {
      btn.textContent = 'Añadir al carrito →';
      btn.disabled = false;
      alert('Error al añadir al carrito. Inténtalo de nuevo.');
    }
  }

  async function search() {
    const pnr = $('arcube-pnr').value.trim().toUpperCase();
    if (!pnr) { $('arcube-pnr-error').textContent = 'Introduce tu número de reserva'; return; }
    $('arcube-pnr-error').textContent = '';

    const adults   = parseInt($('arcube-adults').value);
    const children = parseInt($('arcube-children').value);
    const infants  = parseInt($('arcube-infants').value);

    state.pnr = pnr;
    state.passengers = buildPassengers(adults, children, infants);
    state.selected = {};

    showStep('loading');

    try {
      const resp = await fetch(`${API}/api/recommendations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pnr, passengers: state.passengers, fare: 'economy' }),
      });

      if (!resp.ok) throw new Error(`Error ${resp.status}`);
      const data = await resp.json();

      state.recommendations = flattenResult(data.result);
      $('arcube-pnr-display').textContent = pnr;
      renderGrid(state.recommendations);
      showStep('results');
    } catch (err) {
      $('arcube-error-msg').textContent = `No se pudo conectar con el servidor: ${err.message}`;
      showStep('error');
    }
  }

  $('arcube-search-btn').addEventListener('click', search);
  $('arcube-pnr').addEventListener('keydown', e => { if (e.key === 'Enter') search(); });
  $('arcube-back-btn').addEventListener('click', () => { state.selected = {}; showStep('pnr'); });
  $('arcube-retry-btn').addEventListener('click', () => showStep('pnr'));
  $('arcube-checkout-btn').addEventListener('click', addToCart);
})();
